'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bullseye-arrow';
var width = 576;
var height = 512;
var aliases = [127919];
var unicode = 'f648';
var svgPathData = ['M80 256c0-114.9 93.1-208 208-208 16.6 0 32.8 1.9 48.3 5.6 .1 .7 .3 1.5 .4 2.3l7.1 42.5c-6.1 6.1-12.3 12.3-18.4 18.4-11.9-3.2-24.4-4.9-37.3-4.9-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144c0-12.9-1.7-25.4-4.9-37.3 6.1-6.1 12.3-12.3 18.4-18.4l42.5 7.1 2.3 .4c3.7 15.5 5.6 31.7 5.6 48.3 0 114.9-93.1 208-208 208S80 370.9 80 256z', 'M384 48L464-32 496 48 576 80 496 160 429.1 148.8 297 281 263 247 395.2 114.9 384 48zM288 0c23.3 0 45.8 3.1 67.2 8.9-1.4 1.4-8.9 8.9-22.6 22.6l3.7 22.1C320.8 49.9 304.6 48 288 48 173.1 48 80 141.1 80 256s93.1 208 208 208 208-93.1 208-208c0-16.6-1.9-32.8-5.6-48.3l22.1 3.7c13.7-13.7 21.2-21.2 22.6-22.6 5.8 21.4 8.9 43.9 8.9 67.2 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0zm0 112c12.9 0 25.4 1.7 37.3 4.9L282 160.2c-50.2 3.1-90 44.8-90 95.8 0 53 43 96 96 96 51 0 92.7-39.8 95.8-90l43.3-43.3c3.2 11.9 4.9 24.4 4.9 37.3 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 144-144z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullseyeArrow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;